import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { GAM_ORDER_RETARGETING_DEALS_DELIVERY_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const GET_GAM_ORDER_RETARGETING_DEALS_DELIVERY: TypedDocumentNode<Data, Variables> = gql`
  ${GAM_ORDER_RETARGETING_DEALS_DELIVERY_FRAGMENT}

  query getGamOrderRetargetingDealsDelivery($id: ID!) {
    node(id: $id) {
      ... on Workspace {
        gamOrderRetargetingDealsDelivery {
          ...GamOrderRetargetingDealsDeliveryFragment
        }
      }
    }
  }
`
